import {IGlobalError} from '../../shared-components/components/global-error-display/models/global-error';
import {IUser} from '../../../features/user-access/models';


export function generateGlobalError(
  actionString: string,
  actionType: string,
  error: IGlobalError,
  user: IUser,
  storeIds?: string[],
): IGlobalError {
  return {
    ...error,
    action: actionString,
    actionType,
    originalError: error,
    ...(user?.id && {userId: user.id}),
    ...(storeIds && {storeIds}),
  };
}